// extracted by mini-css-extract-plugin
export var chevronIcon = "_e1-2";
export var teamName = "_e1-1";
export var teamSwitcherButton = "_e1-0";